import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiConfigs } from '../../../api/APIConfigs';
import { UploadResult } from '../../../api/models/UploadResult';
import { routes } from '../../../route-list';
import { useRequest } from '../../../util/use-request';
import { ChurchFormScreen } from '../components/ChurchFormScreen';
import { ChurchFormState, churchInitialFormState } from '../church-form.helper';
import { Church, CreateChurch } from '../../../api/models/Church';

/**
 * Why is this not following the same structure as (link below)?
 * https://github.com/smashingboxes/arno/blob/dev/src/modules/home/containers/HomeContainer.tsx
 *
 * Reason 1: Don’t call Hooks inside loops, conditions, or nested functions
 * (https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level)
 * Reason 2: Don’t call Hooks from regular JavaScript functions.
 * (https://reactjs.org/docs/hooks-rules.html#only-call-hooks-from-react-functions)
 */
export const AddChurchContainer = () => {
  const history = useHistory();
  const request = useRequest();

  const [formState, setFormState] = useState<ChurchFormState>(churchInitialFormState);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <ChurchFormScreen
      mode="add"
      formState={formState}
      isLoading={isLoading}
      userUpdatedFormState={setFormState}
      userClickedSaveSection={async () => {
        try {
          // if (!formState.thumbnail) throw new Error('Please choose a thumbnail!');
          // if (!formState.markdown) throw new Error('Content must not be empty!');

          // setIsLoading(true);

          // let imageUrl = '';
          // if (formState.thumbnail) {
          //   const uploadResult = await request<UploadResult>(apiConfigs.uploadImage(formState.thumbnail));
          //   imageUrl = uploadResult.filePath;
          // }

          await request(
            apiConfigs.addChurch({
              name: formState.name,
              address: formState.address,
              phone: formState.phone,
              logo: '',
            })
          );
          toast.success('Church section added!');
          history.push(routes.CHURCH);
        } catch (e: any) {
          toast.error(e.message || 'Failed to save church!');
        } finally {
          setIsLoading(false);
        }
      }}
      userClickedCancel={() => {
        history.push(routes.CHURCH);
      }}
    />
  );
};
